import React from 'react';
import ReactDOM from 'react-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { BrowserRouter } from 'react-router-dom';

import { msalConfig } from './authConfig';
import globalEn from './translations/en/global.json';
import globalEs from './translations/es/global.json';
import App from './App';

i18next
  .init({
    resources: {
      es: {
        global: globalEs
      },
      en: {
        global: globalEn
      }
    },
    lng: 'es',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  })
  .catch(() => {});

export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Root component of the application.
 *
 * Wraps the App component with I18nextProvider and BrowserRouter.
 *
 * @component
 * @returns {JSX.Element} The rendered Root component.
 */
function Root(): JSX.Element {
  return (
    <I18nextProvider i18n={i18next}>
      <BrowserRouter>
        <App msalInstance={msalInstance} />
      </BrowserRouter>
    </I18nextProvider>
  );
}

const rootElement = document.getElementById('root');

if (process.env.NODE_ENV === 'development') {
  ReactDOM.render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>,
    rootElement
  );
} else {
  ReactDOM.render(<Root />, rootElement);
}

/* This code block is checking if the browser supports service workers by verifying if the
'serviceWorker' property exists in the `navigator` object. If service workers are supported, an
event listener is added to the window's 'load' event. */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration);
      })
      .catch((registrationError) => {
        console.log('Error registering Service Worker:', registrationError);
      });
  });
}
